import { CMSService } from 'client/services';

const loader = async () => {
    const [feedbackDescription, feedbackFormConfirmation] =
    await Promise.all([
        CMSService.getFeedbackDescription(),
        CMSService.getFeedbackFormConfirmation()
    ]);
    return { feedbackDescription, feedbackFormConfirmation };
};

export default loader;
